<template>
  <div class="count-down-timer">
    <div class="rule-btn" @click="show">
      <div class="slot-btn">
        <slot></slot>
      </div>
      <div class="default-btn">{{btnText || '规则'}}</div>
    </div>


    <el-dialog
      :visible.sync="visible"
      custom-class="activity-rule-dialog"
      :close-on-click-modal="false"
      :show-close="false"
      @close="visible=false">
      <div class="dialog">
        <div class="dialog-title">
          {{title || '活动规则'}}
        </div>
        <div class="dialog-content-wrap">
          <div class="dialog-content activity-rule-content">
            <div class="html rule-text" v-html="desc"></div>
          </div>
        </div>
        <div class="dialog-close">
          <img class="icon" src="../../assets/imgs/coupon/modal-close.png" @click="visible=false" />
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  props: {
    desc: String,
    title: String,
    btnText: String,
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
};

</script>

<style lang="less" scoped>
.rule-btn {
  .slot-btn:empty + .default-btn{
    display: inline-block;
  }
  .default-btn {
    display: none;
    font-size: 24px;
    color: #91999F;
    line-height: 28px;
  }
}

/deep/ .activity-rule-dialog{
  left: 50%;
  top: 50%!important;
  transform: translate(-50%, -50%);
  &.el-dialog .el-dialog__header {
    padding: 0;
  }
  &.el-dialog .el-dialog__body {
    padding: 0;
  }
  &.el-dialog {
    background: transparent;
    width: auto;
  }
}

.dialog {
  width: 440px;
  .dialog-title {
    position: absolute;
    top: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 146px;
    height: 30px;
    background: green;
    font-weight: 600;
    font-size: 18px;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url(../../assets/imgs/activity/full-amount-activity/rule-title-bg.png) no-repeat center / 100% 100%;
    color: #FFFFFF;
  }
  .dialog-content-wrap{
    width: 100%;
    .dialog-content{
      box-sizing: border-box;
      color: #2F333D;
      background: linear-gradient(#FD524C 0%, #FFC8A5 100%);
      box-shadow: inset 0px 1px 1px 0px rgba(255,255,255,0.46);
      border-radius: 12px;
      padding: 12px;
      .rule-text{
        border-radius: 6px;
        background-color: #fff;
        padding: 22px 12px 22px 12px;
        box-sizing: border-box;
        width: 100%;
        min-height: 476px;
        max-height: 600px;
        text-align: left;
        white-space: pre-wrap;
        font-size: 14px;
        line-height: 1.5em;
        font-weight: normal;
        overflow-y: auto;
      }
    }
  }
  .dialog-close{
    position: absolute;
    bottom: -52px;
    left: 50%;
    transform: translateX(-50%);
    .icon{
      width: 28px;
      height: 28px;
    }
  }
}

.html {
  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }
  td,
  th {
    vertical-align: middle;
    font-size: 14px;
    border: 1px solid #e7e7e7;
    line-height: 1.42857;
    padding: 8px 16px;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/activity/activity-common-rule.vue